import { render, staticRenderFns } from "./newsletter.vue?vue&type=template&id=83dd62d2&scoped=true&lang=pug&"
import script from "./newsletter.vue?vue&type=script&lang=coffee&"
export * from "./newsletter.vue?vue&type=script&lang=coffee&"
import style0 from "./newsletter.vue?vue&type=style&index=0&id=83dd62d2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dd62d2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Wysiwyg: require('/opt/build/repo/node_modules/@bkwld/cloak/components/wysiwyg.coffee').default,KlaviyoForm: require('/opt/build/repo/nuxt-app/components/globals/klaviyo-form.vue').default})
